export const PARTICULAR_WATCHLIST = "PARTICULAR_WATCHLIST";
export const PARTICULAR_WATCHLIST_STREAM = "PARTICULAR_WATCHLIST_STREAM";
export const PARTICULAR_WATCHLIST_CLEAR_DATA = "PARTICULAR_WATCHLIST_CLEAR_DATA";
export const PARTICULAR_WATCHLIST_ERROR = "PARTICULAR_WATCHLIST_ERROR";
export const PARTICULAR_WATCHLIST_HIDE_ERROR = "PARTICULAR_WATCHLIST_HIDE_ERROR";
export const PARTICULAR_WATCHLIST_START_LOADER = "PARTICULAR_WATCHLIST_START_LOADER";
export const PARTICULAR_WATCHLIST_STOP_LOADER = "PARTICULAR_WATCHLIST_STOP_LOADER";
export const PARTICULAR_WATCHLIST_APPLY_SORT_ = "PARTICULAR_WATCHLIST_APPLY_SORT_";
export const PARTICULAR_WATCHLIST_CLEAR_SORT = "PARTICULAR_WATCHLIST_CLEAR_SORT";
